/**
 * @file automatically generated from MApp.Spatial.Ogc.Extensions.DimensioningGraphic
 */

export enum DimensioningGraphic {
    None = 0,
    ClosedArrow15 = 1,
    ClosedArrow30 = 2,
    OpenArrow15 = 3,
    OpenArrow30 = 4,
    FilledArrow15 = 5,
    FilledArrow30 = 6,
    Diagonal = 7,
    FilledCircle = 8,
    Circle = 9
}
